module.exports = __webpack_public_path__ + "static/media/LogoKushki.08a6d6fc.svg";